// src/components/AcademicRecordItem.js
import React from "react";
import { Row, Col, Form, Input, Select } from "antd";

const { Option } = Select;

export default function AcademicRecordItem({ field }) {
  // used when mapping manually; when used with Form.List the parent supplies the name path
  return (
    <div style={{ border: "1px solid rgba(255,255,255,0.04)", padding: 12, borderRadius: 8 }}>
      <Row gutter={[12, 12]}>
        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "level"]} label="Level" initialValue="UG" rules={[{ required: true }]}>
            <Select>
              <Option value="UG">UG</Option>
              <Option value="PG">PG</Option>
              <Option value="PhD">PhD</Option>
            </Select>
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "degree"]} label="Degree" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "major"]} label="Major">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "course_structure"]} label="Course Structure">
            <Input placeholder="Semester / Annual" />
          </Form.Item>
        </Col>

        <Col xs={12} sm={6}>
          <Form.Item name={[field.name, "start_year"]} label="Start Year">
            <Input type="number" />
          </Form.Item>
        </Col>

        <Col xs={12} sm={6}>
          <Form.Item name={[field.name, "graduation_year"]} label="Graduation Year">
            <Input type="number" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "university_name"]} label="University">
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={6}>
          <Form.Item name={[field.name, "university_country"]} label="University Country">
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
}
